import { ClickTrackingInfo } from "@omni/types/components/tracking/tracking-info/click/click.trackingInfo";

import { EnrichedAnalyticsEvent } from "@/utils/analytics/analytics.types";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsBannerImpression,
    getGoogleAnalyticsBannerImpression
} from "./GoogleAnalyticsBannerImpression";

export interface GoogleAnalyticsBannerSlideClick
    extends GoogleAnalyticsBannerImpression {}

const getGoogleAnalyticsBannerSlideClick = (
    data: EnrichedAnalyticsEvent<ClickTrackingInfo>
): GoogleAnalyticsBannerSlideClick => {
    return getGoogleAnalyticsBannerImpression(
        data,
        GoogleAnalyticsEvents.BannerSlideClick
    );
};

export { getGoogleAnalyticsBannerSlideClick };
